module.exports = __webpack_public_path__ + "img/gw-short-logo.725e41d7.svg";